const PetType = {
  smallDogs: {
    display: 'small dog',
    weightdisplay: '',
  },
  mediumDogs: {
    display: 'medium dog',
    weightdisplay: '',
  },
  largeDogs: {
    display: 'large dog',
    weightdisplay: ' (40+ pounds)',
  },
  cats: {
    display: 'cat',
    weightdisplay: '',
  },
  other: {
    display: 'other',
    weightdisplay: '',
  },
};

export default PetType;
